import React from 'react';
import './DayPicker.css';
import { PropTypes } from 'mobx-react';

import Button from '../Button/Button.js';

import { getWeekdaysShort } from '../../utils/datetime';

const propTypes = {
  activeDays: PropTypes.observableArray.isRequired,
  onDayClick: React.PropTypes.func.isRequired
}

const DayPicker = props => (
  <div className='daypicker'>
    {getWeekdaysShort().map((day, index) => (
      <div className='daypicker__item' key={`daypicker-${day}`}>
        <Button
          textColor={props.activeDays.includes(index + 1) ? 'blue' : undefined}
          type={props.activeDays.includes(index + 1) ? 'white' : 'outline'}
          size='sm'
          onClick={function() {
            props.onDayClick(index + 1);
          }}>
          {day}
        </Button>
      </div>
    ))}
  </div>
)

DayPicker.propTypes = propTypes;

export default DayPicker;



// WEBPACK FOOTER //
// ./src/components/DayPicker/DayPicker.js